module.exports = __webpack_public_path__ + "img/Icon_LaitFichier 51Herd_Simul.01e71315.png";